export const useResponseExceptionMessage = (error) => {
    if(!error) {
        return null;
    }

    const message = error?.response?.data?.message;

    if(message) {
        return message;
    }

    const code = error?.response?.code;

    switch(code) {
        case 429:
            return "Please try again in 5 minutes";
        case 404:
            return "Unable to find what you were looking for";
        case 403:
            return "You do not have the required permissions to do this";
        case 401:
            return "You need to be logged in to do this";
        default:
            return error.message || "Unable to process your request";
    }
}

export const useFormatValidationErrors = (error, errors = {}) => {
    if(error?.response?.status === 422 && error?.response?.data?.errors) {
        Object.keys(error.response.data.errors).forEach(k => {
            if(Array.isArray(error.response.data.errors[k]) && error.response.data.errors[k].length > 0) {
                errors[k] = error.response.data.errors[k].find(i => true);
            }
        });
    }

    return errors;
}
